
const state = {
   canEdit: false,
   isEditing: false,
   editingIds: {},
   newBlock: {
     showButtonInHeader: false,
     showModal: false,
     savingBlock: false,
     errorSaving: false,
     isDragging: false,
     modalCloseReason: '',
     amountSaving: 0,
   },
   loomPublicAppId: "8ba2b237-d638-4666-8ea4-6fa22c09e155",
};
const getters = {
};
const actions = {

};
const mutations = {

  startDragging(state){
    state.newBlock.isDragging = true;
  },
  stopDragging(state){
    state.newBlock.isDragging = false;
  },
  setViewingConcept(state, { conceptId }) {
    state.viewingConcept = conceptId;
  },
  setSavingBlock(state, {reason, message }) {
    if(reason == 'starting'){
      state.newBlock.amountSaving++;
      state.newBlock.savingBlock = true;

    } else if(reason == 'success'){
      state.newBlock.amountSaving--;

    } else if(reason == 'error') {
      state.newBlock.errorSaving = true;
      state.newBlock.errorSavingMessage = message;
      state.newBlock.amountSaving--;
    }

    if(state.newBlock.amountSaving == 0){
      state.newBlock.savingBlock = false;
    }
  },
  setShowNewBlockInHeader(state, { newValue }) {
    state.newBlock.showButtonInHeader = newValue;
  },
  openNewBlock(state) {
    state.newBlock.showModal = true;
  },
  closeNewBlock(state, { reason }) {
    state.newBlock.showModal = false;
    state.newBlock.modalCloseReason = reason;
  },
  setCanEdit(state, { newValue }) {
    state.canEdit = newValue;
  },
  setIsEditing(state, { newValue, editingId }) {
    state.isEditing = newValue;
    state.editingIds[editingId] = {editing: true, result: 0};
    console.log(state.editingIds);
  },
  stopEditing(state, { reason, editingId }) {

    // handle a single editing element successfully saving
    if(reason == 'success'){
      state.editingIds[editingId] = {editing: false, result: 'success'};

      setTimeout(function(){
        delete state.editingIds[editingId];
        if(Object.keys(state.editingIds).length === 0) {
          state.isEditing = false;
        }
      }, 300);

    // Handle canceling of all currently editing elements
    } else if(reason == 'esc') {
      for (var key in state.editingIds) {
        state.editingIds[key] = {editing: false, result: 'canceled'};
      }

      setTimeout(function(){
        state.editingIds = {};
        state.isEditing = false;
      }, 300);
    }
  }
};

export default {
   state,
   getters,
   actions,
   mutations
}
